import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { useCompany } from "../../components/layout/CompanyLayout";
import { PageHeader } from "../../components/common/States";
import AnnouncementsManager from "../../components/comms/AnnouncementsManager";
import CampaignsTab from "../../components/comms/CampaignsTab";
import ContactsTab from "../../components/comms/ContactsTab";
import TemplatesTab from "../../components/comms/TemplatesTab";

export default function Communication() {
  const { can } = useCompany();
  const manage = can("comms:manage");
  return (
    <div>
      <PageHeader title="Communication & marketing" description="Annonces publiées dans votre espace et campagnes email, strictement séparées des emails transactionnels." />
      <Tabs defaultValue="announcements">
        <TabsList className="mb-6 flex-wrap">
          <TabsTrigger value="announcements" data-testid="tab-announcements">Annonces</TabsTrigger>
          <TabsTrigger value="campaigns" data-testid="tab-campaigns">Campagnes</TabsTrigger>
          <TabsTrigger value="templates" data-testid="tab-templates">Modèles</TabsTrigger>
          <TabsTrigger value="contacts" data-testid="tab-contacts">Contacts & listes</TabsTrigger>
        </TabsList>
        <TabsContent value="announcements"><AnnouncementsManager base="/company/announcements" canManage={manage}
          categories={["horaires", "fermeture", "services", "pratique", "amelioration"]} audiences={["both", "public", "reviewers"]} /></TabsContent>
        <TabsContent value="campaigns"><CampaignsTab canManage={manage} canSend={can("comms:send")} /></TabsContent>
        <TabsContent value="templates"><TemplatesTab canManage={manage} /></TabsContent>
        <TabsContent value="contacts"><ContactsTab canManage={manage} /></TabsContent>
      </Tabs>
    </div>
  );
}
